/* eslint-disable */
var appConfig = require('webpack-config-loader!../app-config.js');
/* eslint-enable */

export const handleAppUrl = () => {
  const url = appConfig.scApiUrl;
  if (url.includes('dev')) {
    return 'https://dev.shippingcart.com';
  }
  if (url.includes('staging')) {
    return 'https://staging.shippingcart.com';
  }
  return 'https://app.shippingcart.com';
};


/** WEBPACK FOOTER **
 ** ./src/utils/urls.js
 **/